/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable comma-style */
/* eslint-disable no-undef */
import { AppStateManager } from './appStateManager';

const props = [
    'activeRoute'
    , 'locality'
    , 'platformCode'
    , 'pageId'
    , 'pageName'
    , 'busDomain'
    , 'routePath'
    , [ 'pageMetaData', { watchDepth: 'reference' } ]
    , [ 'pageSetup', { watchDepth: 'reference' } ]
    , [ 'popupId', { watchDepth: 'reference' } ]
    , [ 'routeParams', { watchDepth: 'reference' } ]
    , [ '_User', { watchDepth: 'reference' } ]
];

export const AppStateManagerDirective = (reactDirective, _Config, _User) => reactDirective(AppStateManager, props, null, { config: _Config, _User });
AppStateManagerDirective.$inject = ['reactDirective', '_Config', '_User'];

angular.module('WB.App').directive('appStateManager', AppStateManagerDirective);
